/**
 * 会計期計算（基幹 BASICINFO 相当: 1960-09-01 起点）。
 * backend/ki_period.py と同じ式。表示・警告用。
 */

const FISCAL_ANCHOR_YEAR = 1960;
const FISCAL_START_MONTH = 9;
const FISCAL_START_DAY = 1;

const pad2 = (n) => String(n).padStart(2, '0');

export const kiForDate = (d) => {
  const anchor = new Date(FISCAL_ANCHOR_YEAR, FISCAL_START_MONTH - 1, FISCAL_START_DAY);
  anchor.setHours(0, 0, 0, 0);
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  if (x < anchor) return 0;
  const fiscalStartThisYear = new Date(x.getFullYear(), FISCAL_START_MONTH - 1, FISCAL_START_DAY);
  fiscalStartThisYear.setHours(0, 0, 0, 0);
  if (x >= fiscalStartThisYear) {
    return x.getFullYear() - FISCAL_ANCHOR_YEAR + 1;
  }
  return x.getFullYear() - FISCAL_ANCHOR_YEAR;
};

export const currentKi = (referenceDate = new Date()) => kiForDate(referenceDate);

export const periodBounds = (ki) => {
  const start = new Date(FISCAL_ANCHOR_YEAR + ki - 1, FISCAL_START_MONTH - 1, FISCAL_START_DAY);
  const end = new Date(FISCAL_ANCHOR_YEAR + ki, FISCAL_START_MONTH - 1, FISCAL_START_DAY);
  end.setDate(end.getDate() - 1);
  return {
    period_start: `${start.getFullYear()}-${pad2(start.getMonth() + 1)}-${pad2(start.getDate())}`,
    period_end: `${end.getFullYear()}-${pad2(end.getMonth() + 1)}-${pad2(end.getDate())}`,
  };
};

export const fiscalPeriodInfo = (referenceDate = new Date()) => {
  const ki = currentKi(referenceDate);
  const { period_start, period_end } = periodBounds(ki);
  const asOf = new Date(referenceDate);
  asOf.setHours(0, 0, 0, 0);
  return {
    current_ki: ki,
    period_start,
    period_end,
    as_of: `${asOf.getFullYear()}-${pad2(asOf.getMonth() + 1)}-${pad2(asOf.getDate())}`,
  };
};

/** API 用の期フィルタパラメータ（period=66 を送らない） */
export const buildPeriodApiFilters = (filters) => {
  const out = { ...filters };
  delete out.period;
  if (filters.currentPeriodOnly) {
    out.currentPeriodOnly = true;
    out.previousPeriodsOnly = false;
  } else if (filters.previousPeriodsOnly) {
    out.currentPeriodOnly = false;
    out.previousPeriodsOnly = true;
  } else {
    out.currentPeriodOnly = false;
    out.previousPeriodsOnly = false;
  }
  return out;
};
